import React from 'react';
import DescriptorDropdown from '../DescriptorDropdown';
import { processSurveysWithFrequencies } from 'utils/filterDataProcessors';

/**
 * Component for displaying and managing survey filters
 */
const SurveysFilter = ({
  surveys,
  filters,
  filterReport,
  onToggleSurvey,
  onClearSurveys,
  onApplyFilter,
  dropdownAbove,
  defaultOpen = false,
  onDeleteFilter
}) => {
  const surveysWithFrequencies = processSurveysWithFrequencies(
    surveys, filters, filterReport
  );

  return (
    <DescriptorDropdown
      name="Surveys"
      codes={surveysWithFrequencies}
      onChecked={onToggleSurvey}
      onClearChecked={onClearSurveys}
      applyFilter={onApplyFilter}
      dropdownAbove={dropdownAbove}
      filterButtonText="Apply Filter"
      subHeader="Filter by Surveys"
      defaultOpen={defaultOpen}
      onDeleteFilter={onDeleteFilter}
    />
  );
};

export default SurveysFilter;
